/* ==========================================================================
   Donaldson BOFA accessory page (V3) — assets/abi-bofa-accessory.js
   Loaded (defer) by sections/bofa-accessory-page.liquid, template product.bofa-accessory-v3. Feature bofa-accessory-page,
   review/bofa-v3-finish-2026-10-23.

   From the islands the section renders (data-bac-config, data-bac-fits = { finderSlug: [name, modelPage, older] },
   data-bac-models = the finder's directory slice, "group|slug|name|chip|status" per line):
     - the "Your BOFA model" select (the finder's directory, plus any fit model the finder lacks, e.g. the Shield), kept for the visit in sessionStorage["abi-bofa-model"] (the key the filter page and the
       finder use; ?model= on the URL wins; "Choose your model" clears it), and the answer card: fits / used with / not listed;
     - the size radios: the price, list line, chosen line and phone bar follow the picked variant, the URL gets ?variant=
       (replaceState); nothing is ever picked for the customer;
     - Add to cart: one POST /cart/add.js, then the Cart V2 drawer; with several sizes and none picked it asks for one;
     - the photo thumbnails, the quantity stepper and the phone sticky add bar.
   Text goes in through textContent only (never innerHTML). No phone number. `core` (pure functions) is exported for Node tests.
   ========================================================================== */
(function (factory) {
  'use strict';
  var core = factory();
  if (typeof module !== 'undefined' && module.exports) { module.exports = core; return; }
  if (typeof document === 'undefined') return;
  var start = function () {
    var roots = document.querySelectorAll('[data-bac]');
    for (var i = 0; i < roots.length; i++) core.mount(roots[i]);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(function () {
  'use strict';
  var MODEL_KEY = 'abi-bofa-model';
  var CART_TIMEOUT = 15000;
  var GROUPS = [
    ['laser', 'Laser fume extraction'], ['electronics', 'Electronics and soldering'], ['3d-printing', '3D printing and additive'],
    ['dust', 'Dust and powders'], ['printing', 'Printing'], ['ilf', 'Inline filter units (ILF)'], ['other', 'Other BOFA products'], ['older', 'Older models']
  ];

  /* ---------- pure helpers ---------- */
  function parseDirectory(text) {
    var out = [];
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var f = line.trim().split('|');
      if (f.length >= 3 && f[1]) out.push({ group: f[0], slug: f[1], name: f[2] });
    });
    return out;
  }
  /* the models the part fits that the finder's directory doesn't have (the Shield, the older AD Oracle): still choosable */
  function extraModels(fits, models) {
    var out = [];
    Object.keys(fits || {}).forEach(function (slug) {
      if (!slug || models.some(function (m) { return m.slug === slug; })) return;
      var f = fits[slug] || [];
      if (f[0]) out.push({ group: f[2] ? 'older' : 'other', slug: slug, name: f[0], extra: true });
    });
    return out;
  }
  /* a Contact link with pn= set to the chosen part number (relative links stay relative) */
  function withPn(href, sku) {
    try {
      var u = new URL(href, 'https://x.invalid');
      u.searchParams.set('pn', sku);
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }
  /* answer for a picked finder slug: { state: 'yes'|'no'|'none', name, page } */
  function answerFor(fits, models, slug, usedWith) {
    if (!slug) return { state: 'none' };
    var f = fits && fits[slug];
    var name = f ? f[0] : '';
    if (!name) { for (var i = 0; i < models.length; i++) if (models[i].slug === slug) { name = models[i].name; break; } }
    if (!name) return { state: 'none' };
    if (f) return { state: 'yes', name: name, page: f[1] || '', usedWith: !!usedWith };
    return { state: 'no', name: name, usedWith: !!usedWith };
  }
  function formatMoney(cents, format) {
    var n = Number(cents) || 0;
    var fixed = (n / 100).toFixed(2);
    var parts = fixed.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var f = String(format || '${{amount}}');
    return f.replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function clampInt(v, lo, hi, dflt) { var n = parseInt(String(v).replace(/[^0-9]/g, ''), 10); if (isNaN(n)) return dflt; return Math.min(hi, Math.max(lo, n)); }

  /* ---------- DOM helpers ---------- */
  function qs(root, sel) { return root ? root.querySelector(sel) : null; }
  function qsa(root, sel) { return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : []; }
  function show(el, on) { if (el) el.hidden = !on; }
  function setText(el, v) { if (el) el.textContent = v == null ? '' : String(v); }
  function readJson(root, sel) { var el = qs(root, sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function sessionStore() { try { return window.sessionStorage; } catch (e) { return null; } }

  var cartChain = null;
  function cartUrl() {
    var r = '/';
    try { if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) r = String(window.Shopify.routes.root); } catch (e) { r = '/'; }
    return (r.charAt(r.length - 1) === '/' ? r : r + '/') + 'cart/add.js';
  }
  function cartAdd(items) {
    var run = function () {
      return new Promise(function (resolve, reject) {
        if (typeof window.fetch !== 'function') { reject({ message: '' }); return; }
        var done = false;
        var ctrl = null;
        try { ctrl = typeof window.AbortController === 'function' ? new window.AbortController() : null; } catch (e) { ctrl = null; }
        var timer = setTimeout(function () { if (done) return; done = true; try { if (ctrl) ctrl.abort(); } catch (e) { /* ignore */ } reject({ message: '' }); }, CART_TIMEOUT);
        var opts = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items }) };
        if (ctrl) opts.signal = ctrl.signal;
        window.fetch(cartUrl(), opts).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, status: r.status, data: data || {} }; });
        }).then(function (res) {
          if (done) return; done = true; clearTimeout(timer);
          if (!res.ok) { reject({ message: res.status === 422 ? String(res.data.description || res.data.message || '').replace(/\.$/, '') : '' }); return; }
          var first = (Array.isArray(res.data.items) && res.data.items[0]) || res.data;
          resolve({ key: first && first.key ? String(first.key) : null });
        }, function () { if (done) return; done = true; clearTimeout(timer); reject({ message: '' }); });
      });
    };
    var prev = cartChain || Promise.resolve();
    var p = prev.then(run, run);
    cartChain = p.then(function () { return null; }, function () { return null; });
    return p;
  }
  function openCart(key) {
    if (typeof window.openFlyoutCart === 'function') { try { window.openFlyoutCart({ addedKey: key }); return; } catch (e) { /* fall back */ } }
    var trig = document.querySelector('.flyout-trigger');
    if (trig) trig.click();
  }

  function mount(root) {
    if (!root || root.__bac) return;
    root.__bac = true;
    var cfg = readJson(root, '[data-bac-config]');
    if (!cfg) return;
    var fits = readJson(root, '[data-bac-fits]') || {};
    var modelsEl = qs(root, '[data-bac-models]');
    var models = parseDirectory(modelsEl ? modelsEl.textContent : '');
    var money = function (c) { return formatMoney(c, cfg.money_format); };
    var live = qs(root, '[data-bac-live]');
    var announce = function (msg) { if (live) { live.textContent = ''; window.setTimeout(function () { live.textContent = msg; }, 30); } };
    root.setAttribute('data-bac-js', 'on');

    /* ---------- photos ---------- */
    var photo = qs(root, '[data-bac-photo] img');
    qsa(root, '[data-bac-thumb]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!photo) return;
        e.preventDefault();
        photo.removeAttribute('srcset');
        photo.src = a.getAttribute('data-src');
        photo.alt = a.getAttribute('data-alt') || '';
        qsa(root, '[data-bac-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
        a.setAttribute('aria-current', 'true');
      });
    });

    /* ---------- sizes ---------- */
    var opts = qsa(root, '[data-bac-opt]');
    var priceEl = qs(root, '[data-bac-price]');
    var listEl = qs(root, '[data-bac-list]');
    var chosenEl = qs(root, '[data-bac-chosen]');
    var mbarPn = qs(root, '[data-bac-mbar-pn]');
    var mbarPrice = qs(root, '[data-bac-mbar-price]');
    function picked() { for (var i = 0; i < opts.length; i++) if (opts[i].checked) return opts[i]; return null; }
    function renderPick(fromUser) {
      var o = picked();
      if (!o) return;
      var price = Number(o.getAttribute('data-price'));
      var list = Number(o.getAttribute('data-list'));
      var from = qs(root, '.bac-price__from');
      if (from) from.hidden = true;
      setText(priceEl, money(price));
      setText(listEl, (list > price ? cfg.list_label + ' ' + money(list) + ' · ' : '') + 'each');
      var sku = o.getAttribute('data-sku');
      setText(chosenEl, 'Part no. ' + sku + ' (' + o.getAttribute('data-label') + ') goes in your cart.');
      setText(mbarPn, sku);
      setText(mbarPrice, money(price));
      // every "Send us a message" link carries the chosen part number, not the first size's
      qsa(root, '[data-bac-contact]').forEach(function (a) { a.setAttribute('href', withPn(a.getAttribute('href'), sku)); });
      cfg.contact = withPn(cfg.contact, sku);
      if (select && select.value) renderAnswer(select.value);
      if (fromUser) {
        announce(o.getAttribute('data-label') + ', part no. ' + sku + ', ' + money(price));
        try { var u = new URL(window.location.href); u.searchParams.set('variant', o.value); window.history.replaceState(window.history.state, '', u.toString()); } catch (e) { /* ignore */ }
      }
    }
    opts.forEach(function (o) { o.addEventListener('change', function () { show(error, false); renderPick(true); }); });

    /* ---------- quantity and Add to cart ---------- */
    var qty = 1;
    var qtyInput = qs(root, '[data-bac-qty]');
    var dec = qs(root, '[data-bac-dec]');
    var inc = qs(root, '[data-bac-inc]');
    var status = qs(root, '[data-bac-status]');
    var error = qs(root, '[data-bac-error]');
    var form = qs(root, '[data-bac-form]');
    var addBtn = qs(root, '[data-bac-add]');
    var mbar = qs(root, '[data-bac-mbar]');
    var mbarBtn = qs(root, '[data-bac-mbar-add]');
    var busyNow = false;
    function renderQty() { if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = String(qty); if (dec) dec.disabled = qty <= 1; if (inc) inc.disabled = qty >= 999; }
    if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); renderQty(); });
    if (inc) inc.addEventListener('click', function () { qty = Math.min(999, qty + 1); renderQty(); });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () { qty = clampInt(qtyInput.value, 1, 999, 1); renderQty(); });
      qtyInput.addEventListener('blur', function () { qtyInput.value = String(qty); });
    }
    function busy(on) {
      busyNow = on;
      [addBtn, mbarBtn].forEach(function (b) {
        if (!b) return;
        var label = qs(b, '[data-slot="label"]');
        if (on) { b.setAttribute('aria-busy', 'true'); if (label) { b.__bacLabel = label.textContent; label.textContent = 'Adding…'; } }
        else { b.removeAttribute('aria-busy'); if (label && b.__bacLabel != null) label.textContent = b.__bacLabel; }
      });
    }
    function add(trigger) {
      if (busyNow || !cfg.available) return;
      var id = cfg.single ? cfg.variant_id : (picked() ? Number(picked().value) : null);
      show(error, false);
      setText(status, '');
      if (!id) {
        setText(error, 'Pick a ' + String(cfg.pick_label || 'size').toLowerCase() + ' first.');
        show(error, true);
        var first = opts[0];
        if (first) { first.focus(); if (trigger === mbarBtn && first.scrollIntoView) first.scrollIntoView({ block: 'center' }); }
        return;
      }
      var o = picked();
      var sku = o ? o.getAttribute('data-sku') : cfg.sku;
      var n = qty;
      busy(true);
      cartAdd([{ id: id, quantity: n }]).then(function (res) {
        busy(false);
        setText(status, 'Added ' + n + ' × ' + sku + ' to your cart.');
        openCart(res.key);
      }, function (e) {
        busy(false);
        setText(error, (e && e.message) || 'We couldn’t add it to your cart. Try again, or send us a message.');
        show(error, true);
        if (trigger === mbarBtn && error && error.scrollIntoView) error.scrollIntoView({ block: 'center' });
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(addBtn); });
    if (mbarBtn) mbarBtn.addEventListener('click', function () { add(mbarBtn); });

    /* phone bar: shown once the buy box has scrolled away */
    var buy = qs(root, '[data-bac-buy]');
    if (mbar && buy && typeof window.IntersectionObserver === 'function') {
      var io = new window.IntersectionObserver(function (entries) { entries.forEach(function (en) { show(mbar, !en.isIntersecting && en.boundingClientRect.top < 0); }); }, { threshold: 0 });
      io.observe(buy);
    }

    /* ---------- model select and answer ---------- */
    var select = qs(root, '[data-bac-model]');
    var ans = qs(root, '[data-bac-ans]');
    var extras = extraModels(fits, models);
    var choosable = models.concat(extras);
    if (select) {
      GROUPS.forEach(function (g) {
        var list = choosable.filter(function (m) { return m.group === g[0]; });
        if (!list.length) return;
        var og = document.createElement('optgroup');
        og.label = g[1];
        list.forEach(function (m) { var op = document.createElement('option'); op.value = m.slug; op.textContent = m.name; og.appendChild(op); });
        select.appendChild(og);
      });
    }
    function renderAnswer(slug) {
      var a = answerFor(fits, choosable, slug, cfg.used_with);
      qsa(root, '.bac-fit__row').forEach(function (r) { if (r.getAttribute('data-model') === slug && slug) r.setAttribute('data-picked', 'true'); else r.removeAttribute('data-picked'); });
      if (!ans) return;
      if (a.state === 'none') { show(ans, false); return; }
      ans.setAttribute('data-state', a.state);
      var mark = qs(ans, '[data-slot="mark"]');
      var title = qs(ans, '[data-slot="title"]');
      var sub = qs(ans, '[data-slot="sub"]');
      var link = qs(ans, '[data-slot="link"]');
      if (a.state === 'yes') {
        setText(mark, '✓');
        setText(title, a.usedWith ? 'We list it for use with the ' + a.name + '.' : 'Yes, it fits the ' + a.name + '.');
        setText(sub, a.usedWith ? 'Send us your setup and we’ll confirm the sizing.' : (opts.length ? 'Pick the size that matches your setup, above.' : ''));
        if (a.page) { link.href = cfg.collections_url + '/' + a.page; setText(link, 'All parts for the ' + a.name); show(link, true); } else show(link, false);
      } else {
        setText(mark, '–');
        setText(title, 'We don’t list it for the ' + a.name + '.');
        setText(sub, 'Send us a message and we’ll tell you what fits it.');
        link.href = cfg.contact + '&model=' + encodeURIComponent(a.name);
        setText(link, 'Send us a message');
        show(link, true);
      }
      show(ans, true);
    }
    var start = '';
    try { start = new URL(window.location.href).searchParams.get('model') || ''; } catch (e) { start = ''; }
    var ss = sessionStore();
    if (!start) { try { start = ss ? (ss.getItem(MODEL_KEY) || '') : ''; } catch (e) { start = ''; } }
    if (select) {
      var known = choosable.some(function (m) { return m.slug === start; });
      select.value = known ? start : '';
      renderAnswer(known ? start : '');
      select.addEventListener('change', function () {
        var slug = select.value;
        // a model the finder doesn't have (extras) isn't kept for the visit: the finder and the filter pages couldn't use it
        var isExtra = extras.some(function (m) { return m.slug === slug; });
        try { if (ss && !isExtra) { if (slug) ss.setItem(MODEL_KEY, slug); else ss.removeItem(MODEL_KEY); } } catch (e) { /* storage blocked */ }
        renderAnswer(slug);
        var a = answerFor(fits, choosable, slug, cfg.used_with);
        if (a.state === 'yes') announce(a.usedWith ? 'Listed for use with the ' + a.name : 'Fits the ' + a.name);
        else if (a.state === 'no') announce('Not listed for the ' + a.name);
      });
    }

    renderQty();
    if (picked()) renderPick(false);
  }

  return { mount: mount, parseDirectory: parseDirectory, answerFor: answerFor, extraModels: extraModels, withPn: withPn, formatMoney: formatMoney, clampInt: clampInt };
});
